import Tooltip from '@mui/material/Tooltip';
import { motion } from "framer-motion";
import { memo, useCallback, useRef, useState } from "react";
import IconButton from "../components/IconButton.tsx";
import Separator from "../components/Separator.tsx";

interface BarraSearchprops {
	buscarSearch: () => void;
	clearSearch?: () => void;
	value: string;
	onChange: (value: string) => void;
	disabled?: boolean;
	placeholder?: string;
}

function BarraSearch({
	buscarSearch,
	clearSearch,
	value,
	onChange,
	disabled = false,
	placeholder = "Pesquisar",
}: BarraSearchprops) {
	const inputRef = useRef<HTMLInputElement>(null);
	const [isFocused, setIsFocused] = useState(false);

	const handleSearch = useCallback(() => {
		buscarSearch();
	}, [buscarSearch]);

	return (
		<div className="filtro-viagens-barra-search-container">
			<motion.div
				onClick={() => {
					inputRef.current?.focus();
				}}
				initial={{ borderColor: "#ccc", backgroundColor: "#fff" }}
				animate={{
					borderColor: isFocused ? "#007bff" : "#ccc",
				}}
				whileHover={{
					borderColor: "#007bff",
					backgroundColor: "#f8f8f8",
				}}
				transition={{ duration: 0.3, ease: "easeInOut" }}
				className="filtro-viagens-barra-search"
			>
				<input
					ref={inputRef}
					placeholder={placeholder}
					className="filtro-viagens-barra-search-input"
					value={value}
					onFocus={() => setIsFocused(true)}
					onBlur={() => setIsFocused(false)}
					onChange={(e) => onChange(e.target.value)}
					onKeyDown={e => {
						if (e.key === 'Enter') {
							e.preventDefault();
							handleSearch();
						}
					}}
				/>
				<div className="buscar-viagens-icon">
					<IconButton
						disabled={disabled}
						icon="Search"
						theme="dark"
						size="xl"
						borderColor="none"
						backgroundColor="#FFFFFF"
						hoverColor="#CCC"
						onClick={handleSearch}
					/>
				</div>
			</motion.div>
			<Separator size="xs" direction="horizontal" />

			{clearSearch && (
				<Tooltip title={<p>Limpar Filtro</p>}>
					<motion.div
						initial={{ rotate: 0 }}
						whileHover={{ rotate: 90 }}
						transition={{ duration: 0.2, ease: "easeInOut" }}
						className="select-field-chevron"
					>
						<IconButton
							disabled={disabled}
							icon="X"
							size="xl"
							borderColor="none"
							onClick={clearSearch}
							backgroundColor="rgba(0, 0, 0, 0)"
							theme="dark"
						/>
					</motion.div>
				</Tooltip>
			)}
		</div>
	);
}

export default memo(BarraSearch);
